// extracted by mini-css-extract-plugin
export default {"drawerRoot":"drawerRoot___uO_Kw"};